/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./multi-line-text.vue?vue&type=template&id=1023598c&scoped=true&"
import script from "./multi-line-text.vue?vue&type=script&lang=js&"
export * from "./multi-line-text.vue?vue&type=script&lang=js&"
import style0 from "./multi-line-text.vue?vue&type=style&index=0&id=1023598c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1023598c",
  null
  
)

export default component.exports